export interface ISpline {
  width: number
  color: string
  points: any
  radius: number
  textureUrl: string
  textureSpeed: number
  close: boolean
}

export type Option = Partial<{
  close: boolean
  radius: number
  width: number
  color: string
  points: any
  textureUrl: string
  textureSpeed: number
}>